export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL'
export const SET_ACTIVE_SLIDER = 'SET_ACTIVE_SLIDER'
export const SET_ACTIVE_PROJECT = 'SET_ACTIVE_PROJECT'



// WEBPACK FOOTER //
// ./src/Stores/actions.js